/*
 * baseSelectController
 * */

class BaseSelectController {
	constructor($log) {
		'ngInject';
		this.$log = $log;
	}

	$onInit() {
		this.$log = this.$log.getInstance('BaseSelectController');
		this.$log.debug('loaded');
	}
}

export default BaseSelectController;
